import { mapState } from "pinia";
import { VNodeChild, defineComponent, h } from 'vue';
import { SelectOption, NSelect, NDatePicker, NDropdown, NButton } from 'naive-ui';

import ComponentBase from '../component-base';

import {useStationStore} from  '~/store/station.store';
import { StationGroup } from '~/api/models/station-group.model';



export default defineComponent({
    extends: ComponentBase,

    components: {
        NSelect,
        NDatePicker,
        NDropdown,
        NButton
    },

    computed: {
        ...mapState(useStationStore, ['groups', 'stations', 'group']),

        options(): SelectOption[] {
            if (!this.groups) {
                return [];
            }

            return this.groups.map((grp: StationGroup) => {
                return {
                    label: grp.label || grp.name,
                    value: grp.id,
                } as SelectOption
            });
        },
    },

    methods: {

        async onDropdownSelect(a, selected: SelectOption): Promise<void> {
            const value = selected?.value;
            const group = this.groups.find((grp: StationGroup) => grp.id === value);

            if (!group) {
                return;
            }

            this.$router.replace({ params: { group: group.name}});

            this.$emit('update:value', group);
        },

        async onSelectionChange(value: string) {
            const group: StationGroup = this.groups.find((grp: StationGroup) => grp.id === value);
            if (!group) {
                return;
            }

            this.$router.replace({ params: { group: group.name}});

            this.$emit('update:value', group)
        },

        renderLabel(option: SelectOption): VNodeChild {
            return [h(
                'span',
                { class: this.group?.id === option.value ? 'has-text-success': 'has-text-white'},
                {
                    default: () => option.label
                }
            )]
        },
    }
});